import { esusApi } from "@/services/api";

export type ResumeIndicatorC1Params = {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	ine?: string;
};

export class ResumeIndicatorC1Data {
	totalAttendances: number = 0;
	totalScheduledAttendances: number = 0;
	totalCitizens: number = 0;
}

export async function getResumeIndicatorC1({ uf, ibgeCode, ...params }: ResumeIndicatorC1Params) {
	const response = await esusApi.get<ResumeIndicatorC1Data>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esf/c1/resume`,
		params
	);
	return response.data || new ResumeIndicatorC1Data();
}
